import { axiosSolve, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    product_edit_store_list: [],
    product_edit_list: [],
    count_product_approve: [],
    product_approve_detail: {}
  },
  mutations: {
    setProductEditList(state, data) {
      state.product_edit_list = JSON.parse(JSON.stringify(data));
    },
    getProductApproveCount(state, data) {
      state.count_product_approve = data;
    },
    getProductEditByProvince(state, data) {
      state.product_edit_store_list = data;
    },
    deleteProductEditFromList(state, product_id) {
      let index = state.product_edit_list.findIndex(
        val => val.product_id == product_id
      );
      let product_obj = state.product_edit_list[index];
      state.product_edit_list.splice(index, 1);
      let index2 = state.product_edit_store_list.findIndex(
        val => product_obj.product_store_id == val.store_id
      );
      state.product_edit_store_list[index2].product_count--;
      let index3 = state.product_edit_store_list[index2].product.findIndex(
        val => product_id == val.product_id
      );
      state.product_edit_store_list[index2].product.splice(index3, 1);
      if (state.product_edit_store_list[index2].product.length == 0) {
        state.product_edit_store_list.splice(index2, 1);
      }
    },
    getProductApproveDetail(state, data) {
      state.product_approve_detail = data;
    }
  },
  actions: {
    async getProductApproveDetail({ commit, dispatch }, configPath) {
      commit("getProductApproveDetail", {});
      let url =
        backendVersion.version +
        "/" +
        configPath.province +
        "/merChant/getDetailProductEdit/productId/" +
        configPath.productID +
        "/productApprove/" +
        configPath.productApprove;
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        console.log("getProductApproveDetail", res);
        commit("getProductApproveDetail", res.data);
        return true;
      }
    },
    async getProductApproveCount({ commit, dispatch }) {
      let url = backendVersion.version + "/merChant/getCountEditProduct";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        console.log("getProductApproveCount", res);
        commit("getProductApproveCount", res);
        return res;
      }
    },
    async getProductEditByProvince({ commit, dispatch }, province) {
      commit("getProductEditByProvince", []);
      let url =
        backendVersion.version +
        "/" +
        province +
        "/merChant/getProductNotApprove";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        console.log("getProductEditByProvince", res.data);
        commit("getProductEditByProvince", res.data);
        return res.data;
      }
    },
    async approveProductEdit({ commit, dispatch }, configPath) {
      let url =
        backendVersion.version +
        "/" +
        configPath.province +
        "/merChant/approveProductEdit/productId/" +
        configPath.productId +
        "/productApprove/" +
        configPath.productApprove;
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form: {} },
        {
          root: true
        }
      );
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        console.log("approveProductEdit", res);
        commit("deleteProductEditFromList", configPath.productId);
        return true;
      }
    },
    async rejectProductEdit({ commit, dispatch }, form) {
      let url =
        backendVersion.version +
        "/" +
        form.province +
        "/merChant/rejectProductEdit/" +
        form.product_id;

      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form: form.data },
        {
          root: true
        }
      );
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        console.log("rejectProductEdit", res);
        commit("deleteProductEditFromList", form.product_id);
        return true;
      }
    },
    async deleteProductEdit({ commit, dispatch }, configPath) {
      let url =
        backendVersion.version +
        "/" +
        configPath.province +
        "/merChant/removeProductEdit/productId/" +
        configPath.productId +
        "/productApprove/" +
        configPath.productApprove;
      let res = await dispatch("fetchGeneral/merchantDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteProductEditFromList", configPath.productId);
        return true;
      }
    }
  },
  getters: {}
};
